import { useCallback, useEffect, useState } from "react";
import Header from "./Header/Header";
import SymbolCard from "./SymbolCard";
import toast from "react-hot-toast";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import Menu from "./Menu/Menu";

// --- NEW PDF IMPORTS ---
import { PDFDownloadLink } from "@react-pdf/renderer";
import SymbolPdf from "./SymbolPdf";

const backend = await new Backend().init();

export default function SymbolQty() {
  const windowSize = useSize();
  const [isLoading, setIsLoading] = useState(false);
  const [allSymbols, setAllSymbols] = useState([]);
  const [filteredSymbols, setFilteredSymbols] = useState([]);
  const [counts, setCounts] = useState({
    nse: 0, nse_cash: 0, options: 0, mcx: 0, mcx_options: 0,
    sgx: 0, crypto: 0, comex: 0, forex: 0, index: 0,
    us_stock: 0, dgcx: 0, ncdex: 0,
  });
  const [currentFilter, setCurrentFilter] = useState(null);

  const handleSymbolQtyResponse = useCallback((r) => {
    setIsLoading(false);
    if (r.error === "False") {
      setAllSymbols(r.symbol);
      setCounts({
        nse: r.nse, nse_cash: r.nse_cash, options: r.options, mcx: r.mcx,
        mcx_options: r.mcx_options, sgx: r.sgx, crypto: r.crypto, comex: r.comex,
        forex: r.forex, index: r.index, us_stock: r.us_stock, dgcx: r.dgcx, ncdex: r.ncdex,
      });
    } else {
      r.logout === 1 ? window.LogOut() : toast.error(r.message);
    }
  }, []);

  const loadSymbolQty = useCallback(async () => {
    setIsLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      user_id: localStorage.getItem("id"),
    };
    try {
      const r = await backend.symbol_qty_list(data);
      handleSymbolQtyResponse(r);
    } catch (err) {
      setIsLoading(false);
      toast.error("Failed to fetch symbol qty data.");
    }
  }, [handleSymbolQtyResponse]);

  useEffect(() => {
    loadSymbolQty();
  }, [loadSymbolQty]);

  const filterSymbols = useCallback((typeIndex) => {
    const types = [
      "nse", "nse_cash", "fo", "mcx", "mcx_options", "sgx",
      "crypto_future", "comex_future", "forex_future", "us_stock", "index", "dgcx", "ncdex",
    ];
    const selectedType = types[typeIndex];
    const filtered = selectedType === undefined ? allSymbols : allSymbols.filter((s) => s.type === selectedType);
    setCurrentFilter(typeIndex);
    setFilteredSymbols(filtered);
  }, [allSymbols]);

  useEffect(() => {
    if (currentFilter === null) {
      setFilteredSymbols(allSymbols);
    }
  }, [allSymbols, currentFilter]);

  // Safe Fallback for Document Filename Formatting
  const appNameUpper = String(window.APP_NAME || 'TARGETEX').toUpperCase();

  return (
    <div key={filteredSymbols.length} style={{ height: windowSize[1] - 100 }}>
      {/* --- FLEX WRAPPER FOR HEADER AND DOWNLOAD BUTTON --- */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingRight: "20px"
      }}>
        <Header {...counts} filter={filterSymbols} />

        {/* DOWNLOAD BUTTON TRIGGER */}
        {!isLoading && allSymbols.length > 0 && (
          <PDFDownloadLink
            document={<SymbolPdf allSymbols={allSymbols} counts={counts} />}
            fileName={`${appNameUpper}_SYMBOL_LIST_RULES.pdf`}
            style={{
              textDecoration: "none",
              padding: "8px 16px",
              color: "#ffffff",
              backgroundColor: "var(--primary)",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "12px",
              whiteSpace: "nowrap",
              transition: "opacity 0.2s"
            }}
          >
            {({ loading }) => (loading ? "Generating PDF..." : "Download PDF")}
          </PDFDownloadLink>
        )}
      </div>

      <Menu />
      {isLoading ? (
        <Loading height={windowSize[1] - 200} />
      ) : filteredSymbols.length === 0 ? (
        <NotFound
          title="Nothing here"
          subtext="No symbols match the current filter."
          height={windowSize[1] - 200}
        />
      ) : (
        <div style={{ height: windowSize[1] - 200, overflowY: "scroll" }}>
          {filteredSymbols.map((item) => (
            <SymbolCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}